import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import QuestionViewDialog from '../question_manage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';
import EmptyState, { EmptyStateActions } from '../../components/EmptyState';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { SolidButton } from '../../components/Button';

export default function Launcher(props) {
  const config = useDialogConfig();

  const question = useConnect('question.byId', {
    id: config.params.questionId
  });

  if (question.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  if (question.state === PayloadStates.ERROR_FETCHING) {
    return (
      <DialogTemplate className="max-w-screen-lg" overflow={false}>
        <CloseDialogButton onCancel={props.onClose} />
        <EmptyState
          border={false}
          icon={ExclamationTriangleIcon}
          title="You do not have permission to view this invitation."
          subtitle="Only the intended recipient can view this page."
        />
      </DialogTemplate>
    );
  }

  if (question.state === PayloadStates.NOT_FOUND) {
    return (
      <DialogTemplate className="max-w-screen-lg" overflow={false}>
        <CloseDialogButton onCancel={props.onClose} />
        <EmptyState
          border={false}
          icon={ExclamationTriangleIcon}
          title="Invitation not found."
          subtitle="The project associated with this invitation no longer exists."
          // subtitle={(
          //   <>
          //     The project associated with this invitation no longer exists, but there are
          //     other chances to make a difference! Take a look at other opportunities here.
          //   </>
          // )}
        >
          <EmptyStateActions>
            <SolidButton
              // label="Explore other opportunities"
              label="Close"
              onClick={props.onClose}
            />
          </EmptyStateActions>
        </EmptyState>
      </DialogTemplate>
    );
  }

  return (
    <QuestionViewDialog
      question={question}
      onCancel={props.onClose}
    />
  );
};
